import React, { useEffect, useState } from 'react';
import ApiConfig from '../../config/ApiConfig';
import Divder from '../CommonComp/Divder';
import MatTable from '../Tables/MatTable';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNewParameters,
  getObjectSubset,
  getParameters,
  handleTheImageOpen,
  formatDate,
  downloadBlobFile,
} from '../../lib/helper';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import {
  imagesForShootsListings,
  updateWaterMark,
  ExportShootImage,
} from '../../Services/imageApis';
import { imageListingItemsSelector } from '../../redux/image';
import ConfirmationModal from '../Modals/ConfirmationModal';
import AllFilters from '../Order/AllFilters';
import { WatermarkData, SortBy, OrderBy } from '../../data/imageData';
import EditImageDetailModelNewShoot from '../Modals/EditImageDetailModelNewShoot';
import ViewImage from '../Modals/ViewImage ';
import SuspendImageModal from '../Modals/SuspendImageModal';
import UploadSuspendImagesModal from '../Modals/UploadSuspendImagesModal';
import { toast } from 'react-toastify';

const column = [
  {
    label: 'Image',
    id: 'image_url',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
        onClick={() => {}}
      >
        <img style={{ maxWidth: 200, maxHeight: 200 }} src={`${columnData}`} />
      </span>
    ),
    onClick: handleTheImageOpen,
    numeric: 'center',
  },
  {
    label: 'Name',
    id: 'name',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
        onClick={() => {}}
      >
        {columnData}
      </span>
    ),
  },
  {
    label: 'Rank',
    id: 'rank',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },
  {
    label: 'Rank1',
    id: 'rank1',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },
  {
    label: 'Sold Count',
    id: 'sold_count',
    format: (columnData) => (
      <span
        style={{ display: 'block', textAlign: 'center', whiteSpace: 'nowrap' }}
      >
        {columnData}
      </span>
    ),
    nextLine: false,
    numeric: 'center',
  },
  {
    label: 'Suspended Date',
    id: 'suspendate',
    format: (columnData) => (
      <>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
          {formatDate(columnData, 'dd/mm/yyyy')}
        </span>
      </>
    ),
    nextLine: true,
  },
];

function ShootIDListingPages({ showCheckbox, setShowCheckbox }) {
  const limitOptions = [10, 50, 100, 250];
  // const limit = 10;
  const [limit, setLimit] = useState(limitOptions[0]);
  const { id } = useParams();
  const [tableListing, setTableListing] = useState([]);
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const { loading, shootImagesIDList } = useSelector(imageListingItemsSelector);
  const [clearSelectedCheckbox, setClearSelectedCheckbox] = useState(false);
  const [imageWatermark, setImageWatermark] = useState({});
  // const [confirmImageWatermark, setConfirmImageWatermark] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [imageSuspendModal, setImageSuspendModal] = useState(false);
  const [imageEditModal, setImageEditModal] = useState(false);
  const [editImageData, setEditImageData] = useState({});
  const [imageShowModel, setImageShowModel] = useState(false);
  const [imageOpenData, setImageOpenData] = useState(null);
  const [suspendModalBulk, setSuspendModalBulk] = useState(false);
  const [selectedImageId, setSelectedImageId] = useState(null);

  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'Sort By',
      id: 'sort_by',
      type: 'select',
      linkedWith: null,
      value: 'sold_count',
      onChange: (e, index) => {
        const sortBy = e.target.value;
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = sortBy;
          return newState;
        });
        handleFilter(
          {},
          {},
          { sort_by: sortBy, order_by: filtersArray[1].value },
        );
      },
      style: {},
      dataArr: SortBy,
      props: {},
      isVisible: true,
    },
    {
      label: 'Order By',
      id: 'order_by',
      type: 'select',
      linkedWith: null,
      value: 'desc',
      onChange: (e, index) => {
        const orderBy = e.target.value;
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = orderBy;
          return newState;
        });
        handleFilter(
          {},
          {},
          { order_by: orderBy, sort_by: filtersArray[0].value },
        );
      },
      style: {},
      dataArr: OrderBy,
      props: {},
      isVisible: true,
    },
    {
      label: 'Search Text',
      id: 'search',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },
  ]);
  const handleFilter = (data, allDatavalues, dataWithValue) => {
    const updatedParams = {
      page: String(1),
      sort_by: filtersArray[0].value,
      order_by: filtersArray[1].value,
      ...dataWithValue,
    };
    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };
  const getListing = async (params = {}) => {
    const payload = {
      page: String(page),
      limit: limit,
      shoot_id: id,
      sort_by: filtersArray[0].value,
      order_by: filtersArray[1].value,
      ...allParams,
      ...params,
    };
    dispatch(imagesForShootsListings(payload));
    setPage(Number(payload.page));
    setEditImageData({});
  };
  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
       newState[1].isVisible = true;
        newState[1].value = '';
        newState[2].isVisible = true;
        newState[2].value = '';
      return newState;
    });
  };

  const getExportFile = async (params = {}, resetState) => {
    try {
      let payload = {
        shoot_id: id,
      };
      const resp = await ExportShootImage(payload);

      if (resp?.status) {
        downloadBlobFile(resp.data, `ShootsImageList`);
        toast.success('Export successful!');
      } else {
        toast.error('Export failed. Please try again.');
      }
    } catch (error) {
      console.error('Error exporting file:', error);
      toast.error('An error occurred while exporting the file.');
    }
  };

  useEffect(() => {
    getListing();
  }, [page, limit]);

  useEffect(() => {
    let params = getParameters();
    setAllParams(params);
  }, [location?.search]);

  const handleClearSelectedCheckbox = (value = false) => {
    setClearSelectedCheckbox(value || false);
  };

  const handleAddNewItem = () => {
    setSuspendModalBulk(true);
  };

  const handleModal = (value = false) => {
    setImageEditModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  useEffect(() => {
    let data = getNewParameters(allParams);
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false });
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page));
      }
    }
    getListing();
  }, [allParams]);

  const handleSuspendModalBulk = (value = false) => {
    setSuspendModalBulk(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const handleSuspendModal = (value = false) => {
    setImageSuspendModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const handleImageModal = (value = false) => {
    setImageShowModel(value);
  };
  const imageActionBody = (data) => {
    setImageOpenData(data);
    setImageShowModel(true);
  };

  useEffect(() => {
    if (shootImagesIDList?.items?.rows?.length >= 0) {
      let data = shootImagesIDList?.items?.rows?.map((item) => {
        return {
          image_url: `${ApiConfig.BASE_IMAGE_URL}${item?.shootid}/${item?.rank}-${item?.Name}.jpg`,
          sno: item.sno,
          name: item.Name,
          rank: item?.rank,
          rank1: item.rank1,
          suspendate: item?.suspendate,
          watermark: item?.watermark,
          sold_count: item?.sold_count,
          image_type: item?.type,
          pricing: item?.pricing,
        };
      });
      setTableListing(data);
    }
  }, [shootImagesIDList?.items]);

  const actionBody = (data) => {
    return (
      <>
        <div style={{ display: 'flex' }}>
          <CustomButton
            className="buttonDense"
            onClick={() => {
              handleSuspendModal(true);
              setEditImageData(data);
            }}
          >
            Suspend
          </CustomButton>
          <CustomButton
            className="buttonDense"
            sx={{
              fontSize: '12px',
              bgcolor: 'buttonSecondary.main',
              color: 'buttonSecondary.contrastText',
            }}
            onClick={() => {
              handleModal(true);
              setEditImageData(data);
            }}
          >
            Edit
          </CustomButton>
        </div>
      </>
    );
  };

  const handleExportFile = async (data, resetState) => {
    let image_id_String = '';
    if (data?.length > 0) {
      image_id_String = data?.join(',');
    }
    const payload = {
      image_id: image_id_String,
      shoot_id: id,
    };
    const resp = await ExportShootImage(payload);

    if (resp?.status) {
      downloadBlobFile(resp.data, `ShootsImageList`);
      toast.success('Export successful!');
      getListing({ page: '1' });
      setPage(1);
      resetState([]);
    } else {
      toast.error('Export failed. Please try again.');
    }
  };

  return (
    <div>
      <Divder spacing={1} />
      <MatTable
        loading={shootImagesIDList?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        action={actionBody}
        imageActionBody={imageActionBody}
        page={page}
        perPage={limit}
        showPageLimit={true}
        pageLimitArray={limitOptions}
        handleChangePageLimit={(e) => {
          setLimit(e.target.value);
          setAllParams({
            ...allParams,
            page: String('1'),
            limit: Number(e.target.value),
          });
        }}
        total={shootImagesIDList?.items?.count || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        pagination={true}
        checkboxEnable={true}
        customCheckboxDataKey={'name'}
        onTableToolbarRightClick={handleExportFile}
        clearSelectedCheckbox={clearSelectedCheckbox}
        handleClearSelectedCheckbox={handleClearSelectedCheckbox}
        onTableToolbarRightSection={
          <div>
            <CustomButton
              sx={(theme) => ({
                fontSize: '12px',
                whiteSpace: 'nowrap',
                bgcolor: 'buttonSecondary.main',
                color: 'buttonSecondary.contrastText',
                [theme.breakpoints.down('md')]: {
                  flex: 1,
                },
              })}
            >
              Export XLS
            </CustomButton>
          </div>
        }
        toolbarEnable={true}
        filtersUrlData={allParams || {}}
        rangeDateFilter
        disableSearch
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
            hasAddNew={true}
            handleAddNewModal={handleAddNewItem}
            addText={'Bulk Suspend'}
            hasDownloadExcelButton={true}
            handleDownloadExcel={getExportFile}
          />
        )}
      />
      <SuspendImageModal
        open={imageSuspendModal}
        handleOpen={handleSuspendModal}
        data={editImageData}
        getListing={getListing}
      />
      <EditImageDetailModelNewShoot
        open={imageEditModal}
        handleOpen={handleModal}
        data={editImageData}
        getListing={getListing}
      />
      <>
        {
          <UploadSuspendImagesModal
            open={suspendModalBulk}
            handleOpen={handleSuspendModalBulk}
            // data={editImageData}
            getListing={getListing}
          />
        }
      </>
      <>
        {imageShowModel && (
          <ViewImage
            open={imageShowModel}
            handleOpen={handleImageModal}
            data={imageOpenData}
          />
        )}
      </>
    </div>
  );
}

export default ShootIDListingPages;
